import { Component, TemplateRef, contentChild, input, model, output } from '@angular/core';
import { toDisplayLabel } from '../../utils/label.util';

export interface TabItem {
  header: string;
  icon?: string;
  disabled?: boolean;
  closable?: boolean;
  id?: string;
}

@Component({
  selector: 'app-primeng-tabs',
  templateUrl: './primeng-tabs.component.html',
  styleUrls: ['./primeng-tabs.component.scss'],
  standalone: false,
})
export class PrimengTabsComponent {
  tabs = input<TabItem[]>([]);
  activeIndex = model<number>(0);
  scrollable = input<boolean>(false);
  styleClass = input<string>('');

  onChange = output<any>();
  onClose = output<any>();

  /** Custom tab content templates. Use <ng-template #tabContent let-tab let-index="index">...</ng-template> */
  tabContent = contentChild<TemplateRef<any>>('tabContent');

  handleValueChange(val: any): void {
    const num = Number(val);
    this.activeIndex.set(Number.isNaN(num) ? 0 : num);
  }

  handleChange(event: any) {
    this.activeIndex.set(event.value ?? event.index);
    this.onChange.emit(event);
  }

  /** Safe tab label - never renders "[object Object]". */
  headerLabel(tab: TabItem): string {
    return toDisplayLabel(tab?.header);
  }

  handleClose(event: any) {
    this.onClose.emit(event);
  }
}
